import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "answer"]

  connect() {
    // Collapse all items initially except the first one (optional)
    this.itemTargets.forEach((item, index) => {
      if (index > 0) {
        item.classList.add("collapsed")
      }
    })
  }

  toggle(event) {
    const item = event.currentTarget.closest("[data-faq-accordion-target='item']")

    if (item.classList.contains("collapsed")) {
      // Expand this item
      item.classList.remove("collapsed")
    } else {
      // Collapse this item
      item.classList.add("collapsed")
    }
  }

  // Optional: expand only one at a time
  toggleExclusive(event) {
    const clickedItem = event.currentTarget.closest("[data-faq-accordion-target='item']")

    this.itemTargets.forEach(item => {
      if (item === clickedItem) {
        item.classList.toggle("collapsed")
      } else {
        item.classList.add("collapsed")
      }
    })
  }
}
